var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('g',{staticClass:"workflow-editor-drawable-connection",attrs:{"id":_setup.props.id}},_vm._l((_setup.paths),function(path,index){return _c('path',{key:_setup.keyForIndex(index),class:_setup.connectionClass,attrs:{"d":path,"stroke-width":_setup.lineWidth,"fill":"none"}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }